export default "__VITE_ASSET__Dbz4wqYm__"